import styled from 'styled-components';

export const AudioContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 640px) {
    gap: 1.5rem;
    margin: 2rem;

    flex-direction: column;
    align-items: center;
  }
`;

export const InlineContainer = styled.div`
  width: fit-content;

  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;

  @media (max-width: 640px) {
    display: none;
  }
`;

export const MobileButtonsContainer = styled.div`
  display: none;

  @media (max-width: 640px) {
    display: flex;
    align-items: center;

    gap: 3rem;
  }
`;

export const IconButton = styled.button`
  border: none;
  background: transparent;

  padding: 0.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  svg {
    path {
      stroke: #fa4e20;
      stroke-width: 1.5px;
    }
  }

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.8);
  }

  @media (max-width: 640px) {
    svg {
      width: 4.5rem;
      height: 4.5rem;
    }
  }
`;

export const AudioPlayer = styled.audio``;

export const DesktopButtonWrapper = styled.div`
  @media (max-width: 640px) {
    display: none;
  }
`;
